<bp-svg-icon *ngIf="brand; else fallbackTpl" [bpTooltip]="noTooltip ? null : brand!.displayName" [name]="brand!.name">
</bp-svg-icon>

<ng-template #fallbackTpl>
	{{ src }}
</ng-template>
